<template>
  <NuxtLayout name="users">
    <div class="hk-pg-body py-0">
      <div class="blogapp-wrap">
        <nav class="blogapp-sidebar">
          <ArticlesSidebar />
        </nav>
        <div class="blogapp-content">
          <div class="blogapp-detail-wrap px-2 py-4">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
